/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSeriesDate/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Simple/Data/format.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function ImageSeriesDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/ImageViewer/Content/ImageSeriesDate"
  
}) {
let constantData = 'Series:'
let patientImages0ImageseriesSeriesDateValueData = fromData.useDataFormat({ viewPath,
context: 'patient_images',
path: '[0].imageseries.series_date',
format: fromFormat.dateISOIn,
})
let aggregateData = fromAggregate.join(constantData, patientImages0ImageseriesSeriesDateValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 marginLeft={dtSpaceS}
 data="'Series:'"
 data="patient_images.[0].imageseries.series_date"
 format="/Simple/Data/format.js dateISOIn"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}